import { render, staticRenderFns } from "./ListProperties.vue?vue&type=template&id=18cefef4&"
import script from "./ListProperties.vue?vue&type=script&lang=js&"
export * from "./ListProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports